import React from "react";
import Comment from "components/molecules/Comment";
import { ICommentDTO, ImageDTO } from "types";
import * as Styled from "./NestedComments.styled";
interface NestedCommentsProps {
  replies: ICommentDTO[];
  image: ImageDTO | null;
  onDelete: (commentId: string) => void;
  nestingLevel: number;
}
const NestedComments: React.FC<NestedCommentsProps> = ({
  replies,
  image,
  onDelete,
  nestingLevel
}) => {
  const flattenedReplies = replies.reduce<ICommentDTO[]>((acc, reply) => {
    if (nestingLevel < 2) {
      acc.push(reply);
      if (reply.replies) {
        acc.push(...reply.replies);
      }
    } else {
      acc.push(reply);
    }
    return acc;
  }, []);
  return <Styled.NestedCommentsContainer data-sentry-element="unknown" data-sentry-component="NestedComments" data-sentry-source-file="index.tsx">
            {flattenedReplies.map((reply: ICommentDTO) => <Comment key={reply.id} comment={reply} image={image} onDelete={onDelete} nestingLevel={nestingLevel + 1} />)}
        </Styled.NestedCommentsContainer>;
};
export default NestedComments;